import { pushDataLayer } from '../../../../utils/datalayer'

export const pushDataLayerReferAFriendSend = (
  referralType: string | undefined
) =>
  pushDataLayer([
    {
      key: 'event',
      value: 'refer a friend'
    },
    {
      key: 'actionType',
      value: 'send'
    },
    {
      key: 'referralType',
      value: referralType || ''
    }
  ])
